import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const springBoardBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/projectflow/'
// 持续发布基础URL
const baseSpringBoardUrl = config.baseSpringBoardUrl
const springBoardBaseUrl = baseSpringBoardUrl + '/api/1.0/security/'
// const guacamoleUrl = config.guacamoleUrl

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

// SpringBoardUser
export const getSpringBoardUserList = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getSpringBoardUserALL = () => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'all',
    headers: baseHeaders,
    method: 'get'
  })
}

export const saveSpringBoardUser = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const deleteSpringBoardUser = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'detail/' + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

export const editSpringBoardUser = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'detail/' + data.userId,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const getSpringBoardUserDetail = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/' + 'detail/' + id,
    headers: baseHeaders,
    method: 'get'
  })
}

// SysUser
export const getSysUserList = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getSysUserALL = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'all',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveSysUser = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const pushSysUser = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'push/' + data.system_user,
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const deleteSysUser = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'editor/' + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

export const editSysUser = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'editor/' + data.id,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const getSysUserDetail = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'systemuser/' + 'editor/' + id,
    headers: baseHeaders,
    method: 'get'
  })
}

// Perm 权限
export const savePerm = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'perm/' + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const editPerm = (data) => {
  return axios.request({
    url: springBoardBaseUrl + 'perm/' + 'detail/' + data.id,
    headers: baseHeaders,
    data: data,
    method: 'put'
  })
}

export const deletePerm = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'perm/' + 'detail/' + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

export const getPermList = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'perm/' + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const getPermDetail = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'perm/' + 'detail/' + id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const getUserPerm = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'springboarduser/perm/',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

// Logs
export const getLogsList = (params) => {
  return axios.request({
    url: springBoardBaseUrl + 'log/springboard/' + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const disconnect = (id, connectid) => {
  return axios.request({
    url: springBoardBaseUrl + 'log/springboard/' + 'disconnect/' + id + '/' + connectid,
    headers: baseHeaders,
    method: 'put'
  })
}

export const generateVideo = (id) => {
  return axios.request({
    url: springBoardBaseUrl + 'log/springboard/' + 'video/' + id,
    headers: baseHeaders,
    method: 'put'
  })
}

// guacamole info
export const getConnectId = (name, params) => {
  return axios.request({
    url: springBoardBaseUrl + 'connect/' + name,
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}
